import * as React from 'react'
import styled from 'styled-components'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { ANIMALS } from 'global'
import { IHand } from 'models'
import { Box, Flex, IFlexProps } from 'components'
import {
  AnimalIconButton,
  ANIMAL_ICON_BTN_SELECTED_STYLES,
} from './AnimalIconButton'

const StyledSlider = styled(Slider)`
  .slick-track {
    display: flex;
    align-items: center;
  }
  .slick-current .animalicon-btn {
    ${ANIMAL_ICON_BTN_SELECTED_STYLES}
  }
`

const Slide = styled(Box)`
  outline: none;
`

interface IAnimalPickerProps extends IFlexProps {
  selectedAnimal: IHand['animal']
  onAnimalSelect: (animal: IHand['animal']) => void
}

export const AnimalPicker = ({
  selectedAnimal,
  onAnimalSelect,
  ...props
}: IAnimalPickerProps) => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 250,
    slidesToShow: 5,
    slidesToScroll: 1,
    initialSlide: ANIMALS.indexOf(selectedAnimal),
    arrows: false,
    centerMode: true,
    centerPadding: '0',
    swipeToSlide: true,
    focusOnSelect: true,
    afterChange: (i: number) => onAnimalSelect(ANIMALS[i]),
    responsive: [
      {
        breakpoint: 321,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  }

  return (
    // @ts-ignore styled-system / styled-components clash
    <Flex
      flexDirection='column'
      width='100%'
      /* Fix for Webflow embed */
      overflow='hidden'
      {...props}
    >
      <StyledSlider {...settings}>
        {ANIMALS.map(animal => (
          <Slide key={animal}>
            <AnimalIconButton name={animal} />
          </Slide>
        ))}
      </StyledSlider>
    </Flex>
  )
}
